/**
 * Convert a Kenyan or Somali MSISDN to strict E.164 (+254… / +252…).
 *
 * Accepts:
 *   • Kenya: 07xxxxxxxxx, 2547xxxxxxxxx, +2547xxxxxxxxx, etc. (12 digits total, including +254)
 *   • Somalia: 06xxxxxxxx, 2526xxxxxxxx, +2526xxxxxxxx, etc. (11-12 digits total, including +252)
 *   • Already E.164 (+254xxxxxxxxxx / +252xxxxxxxxx) → unchanged
 *   • Handles spaces, hyphens, parentheses (e.g., +254 712 345 678, 0712-345-678)
 *   • Handles nested object { phoneNumber: string }
 *
 * Anything else → throws with specific error message.
 *
 * @param {*} input   Phone number input
 * @returns {string}  E.164 formatted number
 */
export function normaliseToE164(input) {
    // Handle nested object input
    let rawInput = input;
    if (typeof input === 'object' && input !== null && 'phoneNumber' in input) {
        rawInput = input.phoneNumber;
    }

    // Convert input to string and clean it (remove spaces, hyphens, parentheses)
    const raw = String(rawInput || '').replace(/[\s\-\(\)]/g, '').trim();
  
    if (!raw) {
      throw new Error('Phone number is required');
    }
  
    // Already in E.164 format
    if (/^\+254\d{9}$/.test(raw)) {
      // Kenyan numbers: +254 followed by 9 digits (12 total)
      return raw;
    }
  
    if (/^\+252\d{8,9}$/.test(raw)) {
      // Somali numbers: +252 followed by 8 or 9 digits (11-12 total)
      return raw;
    }
  
    // Kenya: local format (e.g., 07123456789)
    if (/^0\d{9}$/.test(raw)) {
      // Check if it could be a Kenyan number (10 digits starting with 0)
      return '+254' + raw.slice(1);
    }
  
    // Kenya: country code without plus (e.g., 2547123456789)
    if (/^254\d{9}$/.test(raw)) {
      return '+' + raw;
    }
  
    // Somalia: local format (e.g., 0612345678 or 061234567)
    if (/^0\d{8,9}$/.test(raw)) {
      // Check if it could be a Somali number (9-10 digits starting with 0)
      return '+252' + raw.slice(1);
    }
  
    // Somalia: country code without plus (e.g., 252612345678)
    if (/^252\d{8,9}$/.test(raw)) {
      return '+' + raw;
    }
  
    throw new Error('Unsupported phone number format');
}